import Vue from 'vue'
import App from './App.vue'
import './assets/font/iconfont.css'
import './assets/font/iconfont.js'
import './assets/styles/mobile.scss'
import store from './store'


import "../src/icons"

import jsCookie from 'js-cookie'
Vue.prototype.$cookie = jsCookie  // 在页面里可直接用 this.$cookie 调用




import elementImport from '@/utils/element-import'
Vue.use(elementImport)

// 工具函数
import * as utils from '@/utils'
Vue.prototype.$utils = utils

// 枚举类型
import * as enumTypes from '@/constant'
Vue.prototype.$enumType = enumTypes


import Toast from '@/components/toast/index.vue'

const ToastPlugin = {
  install (Vue) {
    Vue.prototype.$toast = new Vue(Toast).$mount()
    document.body.appendChild(Vue.prototype.$toast.$el)
  },
}
Vue.use(ToastPlugin)
import { Loading } from 'element-ui'
Vue.use(Loading.directive)


import Clipboard from 'clipboard'
Vue.prototype.Clipboard = Clipboard



// 这里原本注册了 vue-lazyload（v-lazy 指令），已整体移除，原因有三：
//
// 1. 它的 loading / error 占位图配的是 img.shiyit.com 上的 gif/png，该域名早已失效
//    （443 拒绝连接），等于每张懒加载图片都要先为一个连不上的占位图白等一次 TCP 失败，
//    加载失败时也拿不到兜底图，最终还是裂图。
// 2. 它的可见性判断依赖滚动事件，首屏偶发不触发；而且列表容器在骨架屏期间是
//    display:none，这时判定为不可见，之后不滚动就一直不加载。
// 3. 全站的 v-lazy 已经全部换成 <smart-img>（见 src/components/smart-img/index.vue），
//    用原生 loading="lazy" + 首屏 eager，占位图是本地内联 SVG，零请求。
//
// 依赖 vue-lazyload 本身还留在 package.json 里，确认无回退需求后可以一并卸掉。


import router from './router'

// 移动端返回键处理（图片预览等全屏覆盖层）
import { initMobileBackHandler } from '@/utils/mobileBackHandler'
initMobileBackHandler()

// 视口尺寸 → vuex（全站移动端布局分支的唯一数据源）
import { initDeviceListener } from '@/utils/device'
initDeviceListener(store)

// SEO：注册 vue-meta-info，使各页面 metaInfo 中的 title/keywords/description 生效
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)


// 全局组件注册
import GlobalComponents from '@/utils/globalComponents'
Vue.use(GlobalComponents)

window.vm = new Vue({
  store,
  router,
  render: h => h(App),
  mounted () {
    // 通知 prerender-spa-plugin：页面已渲染完毕，可以抓取快照
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')



